// Design tokens — single source of truth for the Dog Zones theme.
// Direction: modern & minimal, restrained green accent, light + dark.

export const lightTokens = {
  primary: {
    main: "#1F7A5C",
    dark: "#155C44",
    light: "#E6F2EC",
    contrastText: "#FFFFFF",
  },
  background: {
    default: "#FAFAF9", // warm off-white app background
    paper: "#FFFFFF", // cards / surfaces
  },
  text: {
    primary: "#18181B",
    secondary: "#52525B",
  },
  divider: "#E7E5E4",
  error: {
    main: "#DC2626",
  },
} as const;

export const darkTokens = {
  primary: {
    main: "#3FB984", // brighter for contrast on dark surfaces
    dark: "#2E9B6C",
    light: "#16312A", // tonal background for selected/hover states
    contrastText: "#06140F",
  },
  background: {
    default: "#0F1115",
    paper: "#1A1D23",
  },
  text: {
    primary: "#F4F4F5",
    secondary: "#A1A1AA",
  },
  divider: "#27272A",
  error: {
    main: "#F87171",
  },
} as const;

// Shared shape tokens
export const radius = {
  card: 12,
  button: 10,
  input: 10,
} as const;

// Soft, low-opacity shadow used in place of MUI's default heavy elevation.
export const softShadow = {
  light: "0 1px 2px rgba(24, 24, 27, 0.04), 0 4px 16px rgba(24, 24, 27, 0.06)",
  dark: "0 1px 2px rgba(0, 0, 0, 0.4), 0 4px 16px rgba(0, 0, 0, 0.5)",
} as const;

export const fontFamily = [
  "Inter",
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
].join(",");
